import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Context, INFRA_SETTINGS, REQUEST } from "@hermes/core-app-core";
import { InfraSettings } from "@hermes/core-env-infra";

/**
 * List of cookies that will be forwarded to backends
 */
const ALLOWED_COOKIE_LIST = new Set(["cartId"]);

/**
 * Path used by services to call Cart BFF
 */
const TEMPORARY_CART_BFF_PATH = "/api/cart-checkout";

@Injectable()
export class ForwardCookiesInterceptor implements HttpInterceptor {
    private readonly incomingRequest = inject(REQUEST, { optional: true });
    private readonly context = inject(Context);
    private readonly settings = inject<InfraSettings>(INFRA_SETTINGS);

    public intercept<T>(
        httpRequest: HttpRequest<T>,
        next: HttpHandler,
    ): Observable<HttpEvent<T>> {
        if (
            this.context.isInBrowserMode() ||
            !this.isCallingBackend(httpRequest)
        ) {
            return next.handle(httpRequest);
        }

        const filteredCookies = this.incomingRequest?.headers["cookie"]
            ?.split(";")
            .map((cookie) => cookie.trim())
            .filter((cookie) => ALLOWED_COOKIE_LIST.has(cookie.split("=")[0]))
            .join("; ");
        if (!filteredCookies) {
            return next.handle(httpRequest);
        }

        return next.handle(
            httpRequest.clone({
                // eslint-disable-next-line @typescript-eslint/naming-convention
                setHeaders: { Cookie: filteredCookies },
            }),
        );
    }

    private isCallingBackend<T>(httpRequest: HttpRequest<T>): boolean {
        return (
            httpRequest.url.startsWith(this.settings.backendSSR ?? "") ||
            httpRequest.url.startsWith(this.settings.hcomGatewaySSR) ||
            // Until Hcom Gateway is ON, calls to Cart BFF are made with a relative URL
            httpRequest.url.startsWith(TEMPORARY_CART_BFF_PATH)
        );
    }
}
